module.exports = new __parcel__URL__("logo_with_text.d0bb7d35.webp").toString();